module.exports = __webpack_public_path__ + "static/media/raw-materials.dd790f45.svg";